// Every `process.env.NEXT_PUBLIC_*` reference below must stay on ONE line, hence the
// `// prettier-ignore` markers. The values are not real env vars in the image build
// (.dockerignore excludes .env*) - the `inject-secrets` step in the cloudbuild files
// sed-replaces the literal text `process.env.NEXT_PUBLIC_<NAME>`, and sed is line-based.
// Let prettier wrap one of these and the substitution silently misses, shipping
// `undefined` to the browser. scripts/check-injected-env.mjs fails the build on that.
// prettier-ignore
export const API_BASE_URL = "https://connect.agilus.in/" as string
export const CONSUMER_API_BASE_URL = API_BASE_URL + 'consumer-service/'
export const ASSORTED_API_BASE_URL = API_BASE_URL + 'assorted-service/'
export const CMS_API_BASE_URL = API_BASE_URL + 'pulse-cms-service/'
export const SEARCH_API_BASE_URL = API_BASE_URL + 'elastic-service/'
// prettier-ignore
export const GMAP_KEY = "AIzaSyAA9kX5jHH-qTCMLpQHXegeTNuPT-S1P3o"
export const GOOGLE_MAPS_API_BASE_URL =
  'https://maps.googleapis.com/maps/api/js'
// prettier-ignore
export const U_ENC_KEY = "S7HZmWbf1A8X6TofRiiXgOncdLn0JdsDrid88l6CLhc=" as string
// prettier-ignore
export const MOE_APP_ID = process.env.NEXT_PUBLIC_WEB_MOENGAGE_APP_ID as string
// prettier-ignore
export const GA_USER_ID_HASH_KEY = "12345678901234567890123456789012" as string
// prettier-ignore
export const RECAPTCHA_SITE_KEY = "6Lf4BJYsAAAAAHlB30BI69ErhETDdY-U94fXswaB" as string
export const CONSUMER_WEB_PLATFORM = 'CONSUMER_WEB'
export const AGILUS_SUBSIDIARY = 'AGILUS'
export const DDRC_SUBSIDIARY = 'DDRC'
export const PHADKE_SUBSIDIARY = 'PHADKE'
export const CURRENT_SUBSIDIARY = DDRC_SUBSIDIARY
export const INSERT_ACTION = 'INSERT'
export const DELETE_ACTION = 'DELETE'
export const SOMETHING_WENT_WRONG = 'Something went wrong'
export const ADD_ADDRESS = 'ADD_ADDRESS'
export const EDIT_ADDRESS = 'EDIT_ADDRESS'
export const ADDRESS_FIELD_TYPE = 'ADDRESS_FIELD'
export const MAP_VIEW_TYPE = 'MAP_VIEW'
export const FORM_TYPE_LAB_TEST = 'lab test'
export const FORM_TYPE_SCHEDULE_VISIT = 'SCHEDULE_VISIT'

export const paymentVendor = 'EASEBUZZ'
export const WEBLINK_MODE = 'WEBLINK'
export const ONLINE_PAYMENT_MODE = 'PAY_ONLINE'
export const PAY_DURING_COLLECTION_MODE = 'PAY_DURING_COLLECTION'
export const ORDER_DRAFT = 'ORDER_DRAFT'
export const TEST_BY_DISEASE_CATEGORY = 'TEST_BY_DISEASE_CATEGORY'
export const MOST_POPULAR_TEST = 'MOST_POPULAR_TEST'

export const NON_CITY_PRODUCT_PATH = '/non-city-product'
export const PRODUCT_TYPE_TEST_SLUG = 'test'
export const PRODUCT_TYPE_PACKAGE_SLUG = 'package'

// ROUTE_PATHS starts here

export const HOME_PAGE = '/'
export const CHECKOUT_PAGE = '/checkout'
export const ORDER_CONFIRMATION_PAGE = '/order-confirmation'
export const MY_BOOKINGS_PAGE = '/my-bookings'
export const MY_ADDRESS_PAGE = '/my-address'
export const MANAGE_MEMBERS_PAGE = '/manage-members'
export const MY_REPORTS_PAGE = '/my-reports'
export const HEALTH_TRACKER_PAGE = '/health-tracker'
export const ABOUT_US_PAGE = '/about-us'
export const AWARDS_AND_ACCREDITATIONS_PAGE = '/awards-and-accreditations'
export const OUR_SERVICE_PAGE = '/our-services'
export const DOCTORS_PAGE = '/doctors'
export const KEY_MEMBERS_PAGE = '/key-members'
export const OUR_INVESTORS_PAGE = '/our-investors'
export const BECOME_A_VENDOR_PAGE = '/become-a-vendor'
export const PARTNER_WITH_US_PAGE = '/partner-with-us'
export const COMING_SOON_PAGE = '/coming-soon'
export const TERMS_AND_CONDITIONS_PAGE = '/terms-and-conditions'
export const PRIVACY_POLICY_PAGE = '/privacy-policy'
export const DISCLAIMER_PAGE = '/disclaimer'
export const REFUND_AND_CANCELLATION_PAGE = '/refund-and-cancellation'
export const CONTACT_US_PAGE = '/contact-us'
export const FEEDBACK_PAGE = '/feedback'
export const LEAD_PAGE = '/agiluscare'
export const DDRC_LEAD_PAGE = '/landing/ddrcagiluspackages'
export const LEAD_PAGE_INITIAL = '/lp'
export const EDOS_PAGE = '/edos'
export const NEARBY_LABS_PAGE = '/nearest-lab'
export const LAB_DETAILS_PAGE = '/lab-details'
export const AGILUS_UNIVERSE_PAGE = '/agilus-universe'
export const HEALTH_CHECKUP_LISTING_PAGE = '/health-checkup'
export const DISEASE_CATEGORIES_PAGES = '/disease'
export const CARE_PACKAGES_PAGE = '/care-packages'
export const CAREERS_PAGE = '/agilus-careers'
export const BLOG_PAGE = '/blogs'
export const AGILUS_COINS_PAGE = '/agilus-coins'

// ROUTE_PATHS ends here

// id of the product detail section that server-renders every parameter name
// (the "Test included" block in ProductDetailContent). Listing cards link here
// so crawlers reach the parameter text without the modal's client fetch.
export const TEST_INCLUDED_SECTION_ID = 'test-included'

export const PROFILE_PAGES = [
  MY_BOOKINGS_PAGE,
  MY_ADDRESS_PAGE,
  MANAGE_MEMBERS_PAGE,
  MY_REPORTS_PAGE,
  AGILUS_COINS_PAGE,
]

export const PROTECTED_ROUTES = [
  ...PROFILE_PAGES,
  CHECKOUT_PAGE,
  ORDER_CONFIRMATION_PAGE,
  HEALTH_TRACKER_PAGE,
]

export const TOKEN_COOKIE_NAME = 'token'

// Matches the backend's 30-day idle window; re-issued on authenticated activity so it slides the same way.
export const TOKEN_COOKIE_MAX_AGE = 60 * 60 * 24 * 30

export const TOKEN_TOUCHED_AT_KEY = 'tokenTouchedAt'

// One slide a day is plenty against a 30-day window, and keeps the touch off the hot path.
export const TOKEN_TOUCH_INTERVAL = 1000 * 60 * 60 * 24

export const TOKEN_COOKIE_OPTIONS = {
  path: '/',
  secure: true,
  httpOnly: true,
  sameSite: 'none',
  maxAge: TOKEN_COOKIE_MAX_AGE,
} as const

// URLs starts here

export const AGILUS_NEPAL_URL = 'https://agilusdiagnostics.com.np/'
export const DDRC_AGILUS_URL = 'https://ddrcagilus.com/'
export const AGILUS_SITE_URL = 'https://agilusdiagnostics.com/'
export const AGILUS_NEAREST_LAB_URL = 'https://labs.agilusdiagnostics.com'
export const SITE_URL = DDRC_AGILUS_URL.replace(/\/$/, '')

// Hosts that must never be crawled or show the careers page, regardless of which build serves
// them - see middleware.ts and robots.ts. Host, not build target: a domain can get pointed at
// a different backend without a rebuild, so this can't be decided by APP_ENV alone.
export const DEV_CONSUMER_URL = 'https://dev-consumer.agilus.in/'
export const DEV_DDRC_AGILUS_URL = 'https://dev.ddrcagilus.com/'
export const CONSUMER_AGILUS_URL = 'https://consumer.agilus.in/'
export const NON_CRAWLABLE_HOSTNAMES = [
  DEV_CONSUMER_URL,
  DEV_DDRC_AGILUS_URL,
  CONSUMER_AGILUS_URL,
].map((url) => new URL(url).hostname)

// Google Maps URLs
export const GOOGLE_MAPS_SEARCH_URL =
  'https://www.google.com/maps/search/?api=1&query='
export const GOOGLE_MAPS_EMBED_URL = 'https://maps.google.com/maps'

//Site config start
export const SITE_CONFIG = {
  AGILUS: {
    WHATSAPP_URL_WEBPAGE:
      'https://wa.me/+919111591115?text=Hi,%20I%20was%20browsing%20through%20Agilus%20website%20and%20have%20a%20query',
    WHATSAPP_URL_LEAD:
      'https://wa.me/+919111591115?text=Hi,%20I%20found%20Agilus%20on%20google%20and%20would%20like%20to%20book%20a%20test',
    CUSTOMER_CARE_NUMBER: '91115-91115',
    CUSTOMER_CARE_DISPLAY_NUMBER: '+91 91115-91115',
    CUSTOMER_CARE_NUMBER_WITH_COUNTRYCODE: '+919111591115',
    CUSTOMER_CARE_NUMBER_WITH_TEL: 'tel:+919111591115',
    SUPPORT_EMAIL: 'support@agilus.in',
    SUPPORT_EMAIL_WITH_MAILTO: `mailto:support@agilus.in`,
    techEmail: 'tech@agilus.in',
    YOUTUBE_URL: 'https://www.youtube.com/@AgilusCare',
    INSTAGRAM_URL: 'https://www.instagram.com/agilusdiagnostics/',
    FACEBOOK_URL: 'https://www.facebook.com/agilusdiagnostics',
    LINKEDIN_URL: 'https://www.linkedin.com/company/agilusdiagnostics',
    TWITTER_URL: 'https://x.com/agilusDx/',
    WIKIPEDIA_URL: 'https://en.wikipedia.org/wiki/Agilus_Diagnostics',
    PLAY_STORE_URL:
      'https://play.google.com/store/apps/details?id=com.srllimited.srl&hl=en',
    APP_STORE_URL:
      'https://apps.apple.com/in/app/agilus-diagnostics/id840710041',
    COMPLIANCE_PORTAL_URL: 'https://bmwcompliance.agilusdiagnostics.com/',
    EMPLOYEE_PORTAL_URL:
      'https://portal.zinghr.com/2015/Pages/Authentication/agilus.htm',
    WHY_CHOOSE_US_YOUTUBE_URL:
      'https://www.youtube.com/watch?v=GlWrLJb7hIM&list=PLrZXft784xYB-B68jyEBkA1l4yYlZTLK7&index=3',
    LAB_LEAD_SOURCE: 'WebsiteWalkinAgilus',

    defaultLocationObj: {
      city: {
        name: 'New delhi',
        uuid: '332',
        subsidiary: 'AGILUS',
        subsidiaryName: 'Agilus',
        slugName: 'new-delhi',
        lat: 28.5245121,
        lng: 77.1473059,
      },
      latlong: {
        lat: 28.5245121,
        lng: 77.1473059,
      },
    },
  },
  DDRC: {
    WHATSAPP_URL_WEBPAGE:
      'https://wa.me/+919333493334?text=Hi,%20I%20was%20browsing%20through%20DDRC%20Agilus%20website%20and%20have%20a%20query',
    WHATSAPP_URL_LEAD:
      'https://wa.me/+919333493334?text=Hi,%20I%20found%20DDRC%20Agilus%20on%20google%20and%20would%20like%20to%20book%20a%20test',
    CUSTOMER_CARE_NUMBER: '93334-93334',
    CUSTOMER_CARE_DISPLAY_NUMBER: '+91 93334-93334',
    CUSTOMER_CARE_NUMBER_WITH_COUNTRYCODE: '+919333493334',
    CUSTOMER_CARE_NUMBER_WITH_TEL: 'tel:+919333493334',
    SUPPORT_EMAIL: 'support@agilus.in',
    SUPPORT_EMAIL_WITH_MAILTO: `mailto:support@agilus.in`,
    techEmail: 'tech@agilus.in',
    YOUTUBE_URL: 'https://www.youtube.com/@DDRCAgilus',
    INSTAGRAM_URL: 'https://www.instagram.com/ddrcagilusdiagnostics/',
    FACEBOOK_URL: 'https://www.facebook.com/DDRCAgilusDiagnostics',
    LINKEDIN_URL: 'https://www.linkedin.com/company/ddrc-agilus/',
    TWITTER_URL: 'https://x.com/ddrcagilus',
    WIKIPEDIA_URL: '',
    PLAY_STORE_URL:
      'https://play.google.com/store/apps/details?id=com.ddrc&hl=en_IN',
    APP_STORE_URL:
      'https://apps.apple.com/in/app/ddrc-agilus-diagnostics/id1664713246',
    COMPLIANCE_PORTAL_URL: '',
    EMPLOYEE_PORTAL_URL: '',
    WHY_CHOOSE_US_YOUTUBE_URL: 'https://www.youtube.com/watch?v=PzQWdV_Qqb4',
    LAB_LEAD_SOURCE: 'WebsiteWalkinDDRC',
    defaultLocationObj: {
      city: {
        name: 'Kochi',
        uuid: '5001',
        subsidiary: 'DDRC',
        subsidiaryName: 'DDRC',
        slugName: 'kochi',
      },
      latlong: {
        lat: 9.98162641609564,
        lng: 76.30015212764738,
      },
    },
  },
}
//Site config end

export const SUBSIDIARY_CONFIG = SITE_CONFIG?.[CURRENT_SUBSIDIARY]
export const DEFAULT_LOCATION_OBJ = SUBSIDIARY_CONFIG?.defaultLocationObj
export const DEFAULT_CITY_OBJ = DEFAULT_LOCATION_OBJ?.city

// Every city-scoped URL builder needs a slug: a missing one renders a
// crawlable /undefined/ path. DEFAULT_CITY_OBJ is derived from the site config
// with optional chaining, so it can itself be undefined - this is the floor.
export const DEFAULT_CITY_SLUG = DEFAULT_CITY_OBJ?.slugName || 'kochi'
export const DEFAULT_CITY_UUID = DEFAULT_CITY_OBJ?.uuid
export const DEFAULT_CITY_NAME = DEFAULT_CITY_OBJ?.name

// The health-checkup listing has no single product, so its city-prices table is anchored to CBC.
export const HEALTH_CHECKUP_CITY_PRICES_PRODUCT = {
  productId: '100000031',
  name: 'FBS (Fasting Blood Sugar)',
  productType: 'TEST',
  productTypeName: 'test',
}

export const orderConstants = {
  ORDER_PLACED: 'ORDER_PLACED',
  ORDER_DRAFT: 'ORDER_DRAFT',
  ORDER_CONFIRMED: 'ORDER_CONFIRMED',
  SAMPLE_COLLECTED: 'SAMPLE_COLLECTED',
  REPORT_IN_PROCESS: 'REPORT_IN_PROCESS',
  REPORT_READY: 'REPORT_READY',
  CANCELLED: 'CANCELLED',
}

export const mobileNumberRegexEx =
  /^(?:(?:\+|0{0,2})91(\s*[\-]\s*)?|[0]?)?[6789]\d{9}$/
